/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { stripesConnect, withStripes } from '@folio/stripes-core';
import { useIntl } from 'react-intl';
import { okapi } from 'stripes-config';
import MultiEditForm from './MultiEditForm';

function MultiEditManager(props) {
  const intl = useIntl();

  const onFormSubmit = (values) => {
    const newTrans = {};
    Object.keys(values).forEach((key) => {
      newTrans[key.replaceAll('__', '.')] = values[key];
    });

    fetch(`${okapi.url}/translations/messages`, {
      method: 'PATCH',
      headers: {
        'X-Okapi-Tenant': okapi.tenant,
        'X-Okapi-Token': props.stripes.okapi.token,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        localeValue: props.currentLocale,
        categoryName: props.paneTitle,
        messages: newTrans,
      }),
    }).then((res) => {
      if (res.ok) {
        props.handleClose();
        if (intl.locale === props.currentLocale) {
          props.stripes.setTranslations(newTrans);
        }
      }
    });
  };

  const getFormInitialValues = () => {
    const { contentData } = props;
    const fields = {};

    contentData.forEach((trans) => {
      fields[trans.translationKey.replaceAll('.', '__')] =
        trans.localeTranslation;
    });
    return fields;
  };

  return (
    <>
      <MultiEditForm
        {...props}
        onSubmit={onFormSubmit}
        initialValues={getFormInitialValues()}
        selectedTranslations={props.contentData}
      />
    </>
  );
}

MultiEditManager.propTypes = {
  stripes: PropTypes.object,
  currentLocale: PropTypes.string,
  paneTitle: PropTypes.string,
  contentData: PropTypes.array,
  handleClose: PropTypes.func,
};

MultiEditManager.manifest = {};

export default withStripes(MultiEditManager);
